module.exports = __webpack_public_path__ + "img/Icon-block-checkup-32px-groen.06401ff2.svg";